import React, { Component } from "react";
import Chart from "react-apexcharts";

class PSGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chart: {
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 1000,
          animateGradually: {
            enabled: true,
            delay: 0,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 800,
          },
        },
      },
      options: {
        labels: [
          "Unassigned",
          "Assigned",
          "Work in progress",
          "Completed",
          "Pending",
        ],

        colors: ["#D38447", "#34AE7A", "#2C827C", "#006D7C", "#DF5E2B"],

        chart: {
          dropShadow: {
            enabled: false,
            enabledOnSeries: undefined,
            top: 0,
            left: 0,
            blur: 3,
            color: "#000",
            opacity: 0.35,
          },
        },

        legend: {
          show: false,
        },

        tooltip: {
          enabled: true,
          inverseOrder: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },

        dataLabels: {
          enabled: true,
          textAnchor: "middle",
          distributed: true,
          style: {
            fontSize: "9px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },

          dropShadow: {
            enabled: true,
            top: 2,
            left: 2,
            blur: 2,
            color: "#000",
            opacity: 0.5,
          },

          formatter: function (value, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, value.toFixed(3) + "%"];
          },
        },

        plotOptions: {
          pie: {
            startAngle: 180,
            endAngle: 540,
            donut: {
              size: "43%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "11px",
                  colors: [
                    "#F4F1DE",
                    "#E07A5F",
                    "#3D405B",
                    "#81B29A",
                    "#F2CC8F",
                  ],
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  offsetY: -3,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Project Status",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#373d3f",
                },
              },
            },
          },
        },
      },
      series: [25, 40, 65, 30, 0],
    };
  }

  render() {
    return (
      <div className="donut">
        <Chart
          options={this.state.options}
          series={[
            this.props.data.Unassigned,
            this.props.data.Assigned,
            this.props.data.Workinprogress,
            this.props.data.Completed,
            this.props.data.Pending,
          ]}
          type="donut"
          height="280"
        />
      </div>
    );
  }
}

export default PSGraph;
